import { render } from "./PivotEntities.vue?vue&type=template&id=10105776&ts=true"
import script from "./PivotEntities.vue?vue&type=script&lang=ts"
export * from "./PivotEntities.vue?vue&type=script&lang=ts"

import "./PivotEntities.vue?vue&type=style&index=0&id=10105776&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__